import {Activities} from './Activities';
export default Activities;
